import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
export function FAQ() {
  const faqs = [{
    q: '¿Necesito herramientas industriales de velas?',
    a: 'No. Usás las mismas herramientas que tenés en tu cocina: ollas, recipientes de vidrio, batidora común y balanza de cocina. Todo es 100% apto para alimentos e higiénico.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Al instante. Una vez aprobado el pago, te llega un mail de Hotmart con el acceso para descargar los dos tomos y todos los bonos en formato PDF en tu celular, tablet o computadora para siempre.'
  }, {
    q: '¿Es seguro el pago?',
    a: 'Totalmente. Usamos Hotmart, la plataforma líder de productos digitales, con cifrado de seguridad y opciones locales en Argentina como Mercado Pago, tarjetas de crédito, débito o transferencia.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-14 px-6 bg-brand-ivory" data-id="element-50">
      <div className="max-w-3xl mx-auto" data-id="element-51">
        <div className="text-center mb-8" data-id="element-52">
          <h2 className="text-3xl font-serif font-bold text-brand-choco-deep" data-id="element-53">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>
        </div>

        <div className="space-y-4" data-id="element-54">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className="bg-white rounded-xl border border-brand-choco/10 overflow-hidden shadow-sm" data-id="element-55">
                <button onClick={() => setOpenIndex(isOpen ? null : i)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" aria-expanded={isOpen} data-id="element-56">
                  <span className="font-bold text-brand-choco-deep text-lg pr-4" data-id="element-57">
                    {faq.q}
                  </span>
                  <span className="text-brand-gold flex-shrink-0" data-id="element-58">
                    {isOpen ? <RemoveIcon data-id="element-59" /> : <AddIcon data-id="element-60" />}
                  </span>
                </button>
                <AnimatePresence data-id="element-61">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-62">
                      <div className="p-6 pt-0 text-brand-choco/80 leading-relaxed border-t border-brand-choco/5 mt-2" data-id="element-63">
                        ➔ {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}